/**
 * @desc
 * - Each value contains the category and action to report the analytic tool
 */
;(function () {
  angular
    .module('contrast.analytics')
    .factory('csAnalyticsEvents', csAnalyticsEvents)

  function csAnalyticsEvents() {
    'ngInject'

    return require('./analytics-events.json')
  }
})()
